<template>
  <div class="container">
    <svg viewBox="-50 -50 600 700">
      <path id="top-curve" d="M 50,250 A 200,200 0 0,1 450,250" fill="transparent" stroke="black" stroke-width="5" />
      <text class="rune-font">
        <textPath xlink:href="#top-curve">
          ᚠᚬᛏ ᛏᛅᛦ ᚠᚱᛅᚾᛏᛁᚾ ᛏᛅᛦ ᛘᛅᚾ ᛅᚢᚴ ᛅᛚᛚᛋ ᚦᚢ ᛁᚴ ᛘᛅᚾ
        </textPath>
      </text>

      <path d="M 50,250 L 50,600" stroke="black" stroke-width="5" />
      <path d="M 450,250 L 450,600" stroke="black" stroke-width="5" />

      <template v-for="(line, index) in formattedText" :key="index">
        <foreignObject
          :x="textX(index)"
          :y="textY(index)"
          :width="textWidth(index)"
          height="30"
        >
          <div class="description">{{ line }}</div>
        </foreignObject>
      </template>
    </svg>
  </div>
</template>

<script>
export default {
  name: "AboutView",
  data() {
    return {
      fullText: `Jag heter Björn Blomber och jag älskar både programmering och problemlösning.
                 Utöver det är jag en person som trivs med att vara fysiskt aktiv och spendera tid i naturen.
                 Mitt arbete som mjukvaruutvecklare kräver mycket mentalt fokus, så för att balansera livet
                 ägnar jag mig åt att leva ut min passion för vikingatiden genom olika aktiviteter utomhus.
                 Jag är djupt fascinerad av vikingakulturen, deras historia och deras tro. 
                 Att fördjupa mig i deras värld ger mig mycket glädje och kunskap. Förutom att lära mig om
                 vikingarna, ägnar jag mig åt tyngdlyftning och deltar i tävlingar då och då.
                 När jag har chansen kombinerar jag min passion för vikingatiden med tyngdlyftning genom att vara med i
                 'Starke Viking'. Det är som strongman-tävlingar, fast utan hjälpmedel.`,
      maxWidth: 700, // Bredd längst ner
      minWidth: 300, // Smalaste bredden högst upp (ökad för bättre utsträckning)
      startY: 110, // Startposition på Y-axeln (ökad för att minska överlapp)
      lineHeight: 20, // Justerat avstånd mellan rader
      curveFactor: 1.1 // Justerar exponenten för bättre kurvning av bredd
    };
  },
  computed: {
    formattedText() {
      let words = this.fullText.split(" ");
      let lines = [];
      let line = "";

      words.forEach(word => {
        if (line.length + word.length > 42) {
          lines.push(line.trim());
          line = "";
        }
        line += word + " ";
      });

      if (line.length > 0) lines.push(line.trim());

      return lines;
    }
  },
  methods: {
    textX(index) {
      let centerX = 250;
      let width = this.textWidth(index);

      return centerX - width / 2;
    },
    textY(index) {
      return this.startY + index * this.lineHeight;
    },
    textWidth(index) {
      let totalLines = this.formattedText.length;
      let proportion = index / totalLines;
      return this.minWidth + Math.pow(proportion, this.curveFactor) * (this.maxWidth - this.minWidth);
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}

.rune-font {
  font-family: "Junicode", sans-serif;
  font-size: 20px;
  fill: black;
}

.description {
  font-family: Arial, sans-serif;
  font-size: 16px;
  text-align: center;
  color: black;
  word-wrap: break-word;
  white-space: normal;
}
</style>
